import { ParsedUrlQueryInput } from 'node:querystring';
import { UrlObject } from 'url';
import { isUndefined, omitBy } from 'lodash';

export const buildUrlWithQuery = (pathname: string, query?: ParsedUrlQueryInput): UrlObject => {
  return {
    ...{
      pathname,
    },
    ...(query
      ? {
          query: omitBy(query, value => isUndefined(value) || value === null || value === ''),
        }
      : {}),
  };
};
